<template>
  <div style="width:70%; margin:0 auto;">
    <div style="margin-top:-50px;"><p align="left">
        <a href="/" style="text-decoration: none;color: #2c3e50;">首页</a>
    </p>
    </div>
    <el-row>
      <el-col :span="24">
        <h1>销售方：销售订单发起->销售发货单发起</h1>
      </el-col>
      <el-col :span="2">
        <el-tag type="danger" style="margin-top:15px;" effect="dark">出库状态</el-tag>
        <el-tag type="danger" style="margin-top:20px;" effect="dark">单据状态</el-tag>
        <el-tag type="danger" style="margin-top:35px;" effect="dark">协同状态</el-tag>
      </el-col>
      <el-col :span="22">
        <p align="left">
          <el-radio v-model="sendOutBound.val" :label="sendOutBound.na.val">{{sendOutBound.na.name}}</el-radio>
          <el-radio v-model="sendOutBound.val" :label="sendOutBound.no.val">{{sendOutBound.no.name}}</el-radio>
          <el-radio v-model="sendOutBound.val" :label="sendOutBound.yes.val">{{sendOutBound.yes.name}}</el-radio>
        </p>
        <el-tabs v-model="sendStatus.val" type="border-card" style="text-align: left">

          <el-tab-pane :name="sendStatus.review.val" :label="sendStatus.review.name">
            <el-tabs v-model="sendXtStatus.val" style="text-align: left">
              <el-tab-pane :name="sendXtStatus.uncooperative.val" :label="sendXtStatus.uncooperative.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.refuse.val" :label="sendXtStatus.refuse.name">
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane :name="sendStatus.reviewed.val" :label="sendStatus.reviewed.name">
            <el-tabs v-model="sendXtStatus.val" style="text-align: left">
              <el-tab-pane :name="sendXtStatus.uncooperative.val" :label="sendXtStatus.uncooperative.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.receiving.val" :label="sendXtStatus.receiving.name">
              </el-tab-pane>
              <!--收货异常-->
              <el-tab-pane :name="sendXtStatus.receivingException.val" :label="sendXtStatus.receivingException.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.receivingConfirmException.val"
                           :label="sendXtStatus.receivingConfirmException.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.receivingRejectionException.val"
                           :label="sendXtStatus.receivingRejectionException.name">
                本方已拒绝
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.complete.val" :label="sendXtStatus.complete.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.refuse.val" :label="sendXtStatus.refuse.name">
                <el-tab-pane :name="sendXtStatus.receivingException.val" :label="sendXtStatus.receivingException.name">
                </el-tab-pane>
                <el-tab-pane :name="sendXtStatus.receivingConfirmException.val"
                             :label="sendXtStatus.receivingConfirmException.name">
                </el-tab-pane>
                <el-tab-pane :name="sendXtStatus.receivingRejectionException.val"
                             :label="sendXtStatus.receivingRejectionException.name">
                  本方已拒绝
                </el-tab-pane>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane :name="sendStatus.closed.val" :label="sendStatus.closed.name">
            <el-tabs v-model="sendXtStatus.val" style="text-align: left">
              <el-tab-pane :name="sendXtStatus.uncooperative.val" :label="sendXtStatus.uncooperative.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.receiving.val" :label="sendXtStatus.receiving.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.receivingException.val" :label="sendXtStatus.receivingException.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.receivingConfirmException.val"
                           :label="sendXtStatus.receivingConfirmException.name">
              </el-tab-pane>
              <el-tab-pane :name="sendXtStatus.receivingRejectionException.val"
                           :label="sendXtStatus.receivingRejectionException.name">
                本方已拒绝
              </el-tab-pane>
              <!--收货异常-->

              <el-tab-pane :name="sendXtStatus.refuse.val" :label="sendXtStatus.refuse.name">
              </el-tab-pane>

              <el-tab-pane :name="sendXtStatus.complete.val" :label="sendXtStatus.complete.name">
              </el-tab-pane>

            </el-tabs>
          </el-tab-pane>
          <el-tab-pane :name="sendStatus.cancel.val" :label="sendStatus.cancel.name">
            <el-tabs v-model="sendXtStatus.val" style="text-align: left">
              <el-tab-pane :name="sendXtStatus.cancel.val" :label="sendXtStatus.cancel.name">
                协同状态已完成需要走取消流程，取消后无法操作任何动作
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <template v-if="
             sendStatus.val!=sendStatus.cancel.val&&
             sendXtStatus.val!=sendXtStatus.receivingRejectionException.val
">
            <div class="btnAreaLeft">
              <btn-show :bound="sendOutBound" :status="sendStatus" :xtStatus="sendXtStatus"
                        :flag="'send'"></btn-show>
            </div>
            <div class="btnAreaRight">
              <el-button type="primary">附件</el-button>
              <el-button type="primary" icon="el-icon-notebook-2">动态记录</el-button>
              <el-button type="primary">设置</el-button>
            </div>
          </template>

        </el-tabs>
      </el-col>


      <el-col :span="24" style="margin-top:50px;">
        <h1>采购方：采购订单接受->采购收货单接受</h1>
      </el-col>
      <el-col :span="2">
        <el-tag type="success" style="margin-top:15px;" effect="dark">入库状态</el-tag>
        <el-tag type="success" style="margin-top:20px;" effect="dark">单据状态</el-tag>
        <el-tag type="success" style="margin-top:35px;" effect="dark">协同状态</el-tag>
      </el-col>
      <el-col :span="22">
        <p align="left">
          <el-radio v-model="receiveInBound.val" :label="receiveInBound.na.val">{{receiveInBound.na.name}}</el-radio>
          <el-radio v-model="receiveInBound.val" :label="receiveInBound.no.val">{{receiveInBound.no.name}}</el-radio>
          <el-radio v-model="receiveInBound.val" :label="receiveInBound.yes.val">{{receiveInBound.yes.name}}</el-radio>
        </p>
        <el-tabs v-model="receiveStatus.val" type="border-card" style="text-align: left">

          <el-tab-pane :name="receiveStatus.empty.val" :label="receiveStatus.empty.name">
            <el-tabs v-model="receiveXtStatus.val" style="text-align: left">
              <!--收货              -->
              <el-tab-pane :name="receiveXtStatus.receiving.val" :label="receiveXtStatus.receiving.name">
              </el-tab-pane>
              <el-tab-pane :name="receiveXtStatus.refuse.val" :label="receiveXtStatus.refuse.name">
                拒收成功
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane :name="receiveStatus.review.val" :label="receiveStatus.review.name">
            <el-tabs v-model="receiveXtStatus.val" style="text-align: left">

              <el-tab-pane :name="receiveXtStatus.receiving.val"
                           :label="receiveXtStatus.receiving.name">
              </el-tab-pane>
              <el-tab-pane :name="receiveXtStatus.confirmReceiving.val" :label="receiveXtStatus.confirmReceiving.name">
              </el-tab-pane>
              <el-tab-pane :name="receiveXtStatus.receivingRejectionException.val"
                           :label="receiveXtStatus.receivingRejectionException.name">
              </el-tab-pane>
              <el-tab-pane :name="receiveXtStatus.refuse.val" :label="receiveXtStatus.refuse.name">
                拒收成功
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane :name="receiveStatus.reviewed.val" :label="receiveStatus.reviewed.name">
            <el-tabs v-model="receiveXtStatus.val" style="text-align: left">
              <el-tab-pane :name="receiveXtStatus.receivingException.val"
                           :label="receiveXtStatus.receivingException.name">
              </el-tab-pane>
              <el-tab-pane :name="receiveXtStatus.receivingRejectionException.val"
                           :label="receiveXtStatus.receivingRejectionException.name">
              </el-tab-pane>
              <el-tab-pane :name="receiveXtStatus.complete.val" :label="receiveXtStatus.complete.name">
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane :name="receiveStatus.closed.val" :label="receiveStatus.closed.name">
            <el-tabs v-model="receiveXtStatus.val" style="text-align: left">
              <el-tab-pane :name="receiveXtStatus.complete.val" :label="receiveXtStatus.complete.name">
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane :name="receiveStatus.cancel.val" :label="receiveStatus.cancel.name">
            <el-tabs v-model="receiveXtStatus.val" style="text-align: left">
              <el-tab-pane :name="receiveXtStatus.cancel.val" :label="receiveXtStatus.cancel.name">
                协同状态已完成需要走取消流程，取消后无法操作任何动作
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>

          <template v-if="
             receiveStatus.val!=receiveStatus.cancel.val&&
             receiveXtStatus.val!=receiveXtStatus.refuse.val
">
            <div class="btnAreaLeft">
              <btn-show :bound="receiveInBound" :status="receiveStatus" :xtStatus="receiveXtStatus"
                        :flag="'receive'"></btn-show>
            </div>
            <div class="btnAreaRight">
              <el-button type="primary">附件</el-button>
              <el-button type="primary" icon="el-icon-notebook-2">动态记录</el-button>
              <el-button type="primary">设置</el-button>
            </div>
          </template>
        </el-tabs>
      </el-col>
    </el-row>
    <div style="padding: 10px;margin-top:30px;margin-left:100px;text-align: left;">
      注：本流程仅支持发货方发起的流程，收货方无推送功能
    </div>
    <div style="margin-bottom: 50px;"></div>
  </div>
</template>
<!--
1、关闭增加推送
2、按钮与协同相关的功能仅影响对方的协同状态，不影响单据状态
3、补齐规范按钮，保持与开发环境1：1
-->
<script>

  import {
    sendOutBound,
    sendStatus,
    sendXtStatus,
    receiveInBound,
    receiveStatus,
    receiveXtStatus
  } from '../data/statusData.js'
  import {sendButtonData, receiveButtonData} from '../data/btnData.js'
  import btnShow from "./components/btnShow";


  export default {
    components: {btnShow},
    data() {
      return {
        radio: '0',
        sendButtonDataEditFlag: false,
        /**
         * 对应货品,flag点击 true点击了
         */
        editRelationFlag: false,
        eidtInFlag: false,
        verifyConfirmAcceptFlag: false,
        receiveButtonDataSaveFlag: false,
        pageFlag: {
          detail: 'detail',
          edit: 'edit'
        },
        sendOutBound: sendOutBound,
        sendStatus: sendStatus,
        sendXtStatus: sendXtStatus,
        receiveInBound: receiveInBound,
        receiveStatus: receiveStatus,
        receiveXtStatus: receiveXtStatus,
        sendButtonData: sendButtonData,
        receiveButtonData: receiveButtonData,
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btnAreaLeft {
    float: left;
    width: 70%;
    background-color: white;
    height: 50px;
  }

  .btnAreaRight {
    text-align: right;
    margin-left: 70%;
    width: 30%;
    background-color: white;
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page1.vue